import parseISO from "date-fns/parseISO"
import sortBy from "lodash/sortBy"
import { pad } from "~/lib/utils"
import { tz, TZDate } from "@date-fns/tz"
import format from "date-fns/format"
import _toDate from "date-fns/toDate"
import endOfMonth from "date-fns/endOfMonth"
import startOfMonth from "date-fns/startOfMonth"

export function toDate(date, { timeZone }) {
    return _toDate(date, { in: tz(timeZone) })
}

export function zonedTimeToUtc(date, timeZone) {
    date = typeof date === "string" ? parseISO(date) : date
    return parseISO(
        new TZDate(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
            date.getMilliseconds(),
            timeZone
        ).toISOString()
    )
}

export function formatInTimeZone(date, timeZone, formatStr) {
    return format(date, formatStr, { in: tz(timeZone) })
}

export function dateInRange(date, start, end) {
    return parseISO(date) >= parseISO(start) && parseISO(date) <= parseISO(end)
}

export function getSortingDate({ eventFromDate, eventToDate, eventType }) {
    switch (eventType) {
        case "start":
        case "start-end":
            return eventFromDate

        case "end":
            return eventToDate

        default:
            throw new Error(`Unexpected eventType ${eventType}`)
    }
}

export function getStartEndDates({ month, year, timeZone }) {
    // We use day 15th so we avoid jumping to a different month due to timezones
    const cookedMonth = toDate(`${year}-${pad(month, 2)}-15`, { timeZone })
    const startDate = zonedTimeToUtc(
        startOfMonth(cookedMonth),
        timeZone
    ).toISOString()
    const endDate = zonedTimeToUtc(
        endOfMonth(cookedMonth),
        timeZone
    ).toISOString()
    return { startDate, endDate }
}

export function sortEvents(events) {
    return sortBy(events, [
        getSortingDate,
        ({ eventType }) => {
            switch (eventType) {
                case "start-end":
                    return 1
                case "start":
                    return 2
                case "end":
                    return 3
                default:
                    throw new Error(`Unexpected eventType ${eventType}`)
            }
        },
    ])
}
